import { render, staticRenderFns } from "./ChangeStatusDialog.vue?vue&type=template&id=63cd0b8e"
import script from "./ChangeStatusDialog.vue?vue&type=script&lang=ts"
export * from "./ChangeStatusDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports